import { Component, Input } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { ISignupStrategyComponent, ISignupStrategyPresenter } from './interfaces';
import { SignupStrategyPresenter } from './signup-strategy.presenter';
import { AuthModalComponentEnum } from '../../../enums';
import { ButtonComponent, InputComponent, IconComponent } from '@shared/components';

@Component({
	selector: 'app-signup-strategy',
	templateUrl: './signup-strategy.component.html',
	styleUrls: ['./signup-strategy.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		IonicModule,
		ButtonComponent,
		InputComponent,
		IconComponent
	],
})
export class SignupStrategyComponent
	extends IAbstractView<ISignupStrategyPresenter>
	implements ISignupStrategyComponent
{
	translations = this.presenter.translations;
	loading$ = this.presenter.loading$;
	loadingStore$ = this.presenter.loadingStore$;
	formGroup = this.presenter.formGroup;
	storeArgentinaLoading$ = this.presenter.storeArgentinaLoading$;
	registered$ = this.presenter.registered$;
	isArgentina = this.presenter.isArgentina;
	identificationTypeEnums = this.presenter.identificationTypeEnums;
	passwordRequirements = this.presenter.passwordRequirements;
	AuthModalComponentEnum = this.presenter.AuthModalComponentEnum;

	@Input({ required: true }) callback = this.presenter.callback;
	@Input() visitingCheckout = this.presenter.visitingCheckout;

	constructor(presenter: SignupStrategyPresenter) {
		super(presenter);
	}

	onSignUp(): void {
		this.presenter.onSignUp();
	}

	openTermsModal(): void {
		this.presenter.openTermsModal();
	}

	formatPhone(event: Event): void {
		this.presenter.formatPhone(event);
	}

	isFieldInvalid(fieldName: string): boolean {
		return this.presenter.isFieldInvalid(fieldName);
	}

	getFieldErrorMessage(fieldName: string): string {
		return this.presenter.getFieldErrorMessage(fieldName);
	}

	getFieldErrorMessages(fieldName: string): string[] {
		return this.presenter.getFieldErrorMessages(fieldName);
	}

	passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
		return this.presenter.passwordMatchValidator(group);
	}

	phoneDigitsValidator(control: AbstractControl): ValidationErrors | null {
		return this.presenter.phoneDigitsValidator(control);
	}

	navigateTo(route: AuthModalComponentEnum): void {
		this.presenter.navigateTo(route);
	}

	getButtonType(isDisabled: boolean | null): 'button-primary' {
		return (isDisabled ? 'button-primary disabled' : 'button-primary') as unknown as 'button-primary';
	}
}
